/* @flow */
import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import NavigationExpandMoreIcon from 'material-ui/svg-icons/navigation/expand-more';
import MenuItem from 'material-ui/MenuItem';
import {
  Toolbar,
  ToolbarGroup,
  ToolbarSeparator,
  ToolbarTitle,
} from 'material-ui/Toolbar';

import type { TutorToolbar_tutor } from './__generated__/TutorToolbar_tutor.graphql';

/*
<ConfirmDialog
  handleSubmit={this.handleAcceptCashUp}
  title="Accept Review"
  message="Are you sure you want to accept the Cash Up?"
  renderSubmitButton={handleButtonClick => (
    <div style={styles.button}>
      <RaisedButton
        primary
        fullWidth
        label="Accept"
        onTouchTap={handleButtonClick}
      />
    </div>
  )}
/>;
*/

type Props = {
  handleApprove: () => void,
  handleLock: () => void,
  handleUnlock: () => void,
  tutor: TutorToolbar_tutor,
};

class TutorToolbar extends Component<Props> {
  renderMenuItems() {
    const { tutor, handleApprove, handleLock, handleUnlock } = this.props;
    const canLock = tutor.user.status !== 'UserStatus.Locked';
    const canUnlock = tutor.user.status === 'UserStatus.Locked';

    const menuItems = [];

    // Always display so we can edit...
    menuItems.push(
      <MenuItem key="approve" primaryText="Approve" onClick={handleApprove} />
    );

    if (canLock) {
      menuItems.push(
        <MenuItem key="lock" primaryText="Lock" onClick={handleLock} />
      );
    }

    if (canUnlock) {
      menuItems.push(
        <MenuItem key="unlock" primaryText="Unlock" onClick={handleUnlock} />
      );
    }

    return menuItems;
  }

  render() {
    return (
      <div>
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text="Tutor" />
            <ToolbarSeparator />
          </ToolbarGroup>
          <ToolbarGroup lastChild>
            <IconMenu
              iconButtonElement={
                <IconButton touch>
                  <NavigationExpandMoreIcon />
                </IconButton>
              }
            >
              {this.renderMenuItems()}
            </IconMenu>
          </ToolbarGroup>
        </Toolbar>
      </div>
    );
  }
}

export default createFragmentContainer(TutorToolbar, {
  tutor: graphql`
    fragment TutorToolbar_tutor on Tutor {
      user {
        status
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/TutorToolbar.js